import { graphql, useStaticQuery } from "gatsby";

import { FAQCollections } from "../components/blocks/faq-collections";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean => {
  return __typename === "VinoData_StaticBlock" && staticType === "Accordion";
};

const create = (props: {
  __typename: string;
  staticType: string;
}): JSX.Element => {
  const { staticType } = props;
  const {
    vinodata: { accordions },
  } = useStaticQuery(ACCORDION_QUERY);
  if (!accordions || accordions.length === 0) return <></>;

  const accordionsData = accordions
    .filter((item) => item.internalName.toLowerCase().includes("whisky"))
    .map((accordion) => {
      return {
        ...accordion,
        collections: accordion.collections.map((collection) => {
          const { textBody } = collection;
          const rawJson =
            typeof textBody === "object" &&
            "json" in textBody &&
            textBody.json.raw
              ? JSON.parse(textBody.json.raw)
              : null;
          return {
            ...collection,
            bodyText: rawJson ? { json: rawJson } : null,
          };
        }),
      };
    });

  return <FAQCollections faqgroup={accordionsData} />;
};

const ACCORDION_QUERY = graphql`
  query {
    vinodata {
      accordions {
        id
        title
        description
        internalName
        collections {
          id
          title
          textBody
          textAlign
          internalName
        }
      }
    }
  }
`;

export default { test, create };
